import { useState } from "react";
import { Button } from "../ui/button";
import { Camera, CameraOff } from "lucide-react";
import { useLivekitContext } from "@/context/features/livekit/LivekitRoomContext";
import { useReceiveActionAccess } from "@/hooks/livekit/useReceiveActionAccess";
import { selectCurrentRoom, setCam } from "@/context/features/room/roomSlice";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentAuth } from "@/context/features/auth/authSlice";
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip";
import { useTranslation } from "react-i18next";

export default function CameraToggle({
  togglefunc,
}: {
  togglefunc: (() => Promise<void>) | undefined;
}) {
  const { livekitContext } = useLivekitContext();
  const { room } = livekitContext ?? {};
  const { isCamOpen } = useSelector(selectCurrentRoom);
  const dispatch = useDispatch();
  const { user } = useSelector(selectCurrentAuth);
  const { t } = useTranslation();

  const [isCameraLocked, setIsCameraLocked] = useState<boolean>(false);

  const cluckHandler = () => {
    if (typeof togglefunc === "function") togglefunc();
    dispatch(setCam(!isCamOpen));
  };
  useReceiveActionAccess("cam", room, ({ type, to }) => {
    if (user?.id.toString() === to) {
      if (type === "lock") {
        if (typeof togglefunc === "function" && isCamOpen) togglefunc();
        dispatch(setCam(false));
      }
      setIsCameraLocked(type === "lock");
    }
  });
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="outline"
          size="icon"
          onClick={cluckHandler}
          disabled={isCameraLocked}
        >
          {isCamOpen ? (
            <Camera strokeWidth={1.5} />
          ) : (
            <CameraOff strokeWidth={1.5} />
          )}
        </Button>
      </TooltipTrigger>
      <TooltipContent side="top">
        {isCameraLocked
          ? t("locked")
          : isCamOpen
            ? t("close_cam")
            : t("open_cam")}
      </TooltipContent>
    </Tooltip>
  );
}
